import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    TouchableOpacity,
    ActivityIndicator,
    ScrollView,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation,
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type {
    OldPresidentData
} from "../../../services/restAPI/actions/getOldPresidents/types";
import type AppStackParamList from "../../../types/navigation/app";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ChevronLeft
} from "lucide-react-native";
import {
    RESTService
} from "../../../services/restAPI";
import {
    PresidentCard
} from "../../../components";

const OldPresidents = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();

    const {
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [data,
        setData] = useState<OldPresidentData[]>();
    const [loading,
        setLoading] = useState(true);

    const inset = useSafeAreaInsets();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => <View
                style={{
                    paddingTop: inset.top,
                    paddingHorizontal: spaces.spacingMd,
                    backgroundColor: colors.content.container.default
                }}
            >
                <TouchableOpacity
                    style={[
                        stylesheet.backButton,
                        {
                            padding: spaces.spacingSm
                        }
                    ]}
                    onPress={() => {
                        navigation.goBack();
                    }}
                >
                    <ChevronLeft
                        size={30}
                    />
                </TouchableOpacity>
                <View
                    pointerEvents="none"
                    style={[
                        stylesheet.headerTitleContainer,
                        {
                            top: inset.top + spaces.spacingSm
                        }
                    ]}
                >
                    <Text
                        variant="titleLargeSize"
                        color="high"
                        style={stylesheet.headerTitle}
                        numberOfLines={1}
                        adjustsFontSizeToFit={true}
                    >
                        {localize("old-presidents")}
                    </Text>
                </View>
            </View>
        });
    }, [navigation]);

    useEffect(() => {
        getOldPresidents();
    }, []);

    const getOldPresidents = () => {
        RESTService.action("GetOldPresidents", null)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    setData(res.payload);
                }
                setLoading(false);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            });
    };

    const renderOldPresidents = () => {
        if (!data) return null;

        return <View
            style={stylesheet.container}
        >
            {data.map((item, index) => <View
                key={index}
            >
                <PresidentCard
                    profilePhotoURL={item.profilePhotoURL}
                    fullName={item.fullName}
                    term={item.term}
                />
            </View>)}
        </View>;
    };

    if(loading) {
        return <PageContainer
            style={stylesheet.loadingContainer}
        >
            <ActivityIndicator
                size={40}
                color={colors.content.icon.default}
            />
        </PageContainer>;
    }

    return <PageContainer
        isScrollable={false}
        style={stylesheet.container}
        backgroundColor="subtle"
    >
        <ScrollView
            style={stylesheet.scrollView}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
        >
            {renderOldPresidents()}
        </ScrollView>
    </PageContainer>;
};
export default OldPresidents;
